import { render, staticRenderFns } from "./OpenCustomerChatButton.vue?vue&type=template&id=78491982"
import script from "./OpenCustomerChatButton.vue?vue&type=script&lang=js"
export * from "./OpenCustomerChatButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports